import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  rootContainer: {
    width: "100%",
    height: "55px",
    display: "flex",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  tabsContainer: {
    marginTop: 4,
    textDecoration: "none",
  },
  text: {
    display: "block",
    color: "#354a5f",
        fontSize: "18px", // Adjust the font size as needed

  },
  tabSelected: {
    color: "#354a5f !important",
  },

  "@media (max-width:570px)": {
    text: {
      display: "none",
    },
  },
}));
